import React, {
  Fragment,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react';
import CollapsibleCard from '../../../components/Exam/reports';
import {
  Button,
  Card,
  Col,
  ListGroup,
  ListGroupItem,
  Row,
} from 'react-bootstrap';
import { FormField } from '../../../components/Form/FormField';
import moment from 'moment';
import {
  RIconAadharBypass,
  RIconDeleteFill,
  RIconEyeFill,
} from '../../../components/Icons';
import AddEditCandidate from './AddEditCandidate';
import { useParams } from 'react-router-dom';
import * as SubmissionsAPI from '../../../api/SubmissionsAPI';
import { handleApiError } from '../../../common/errorHandler';
import {
  IconAlertTriangle,
  IconExclamationMark,
  IconEye,
  IconTrashFilled,
} from '@tabler/icons-react';
import { DEFAULT_CONFIRM_MODAL } from '../../../common/constants';
import { toast } from 'react-toastify';
import ConfirmModal from '../../../components/CustomModal/ConfirmModal';
import { ConfirmOffcanvas } from '../../../components/CustomModal/ConfirmOffcanvas';
import { useSelector } from 'react-redux';

const DEFAULT_CANDIDATE_MODAL = {
  id: null,
  show: false,
  title: 'Add Candidate',
  saveBtnText: 'Save',
};
const ShiftQuestions = ({
  examData,
  shiftData,
  register,
  watch,
  setValue,
  reportError,
  trigger,
  statuses,
  handleSave,
}) => {
  const { id, center_cordinator_id } = useParams();
  console.log('candidate_id', center_cordinator_id);
  // return false;
  const [addEditCandidateModal, setAddEditCandidateModal] = useState(
    DEFAULT_CANDIDATE_MODAL
  );
  const authSelector = useSelector((state) => state.rrb.authUserReducer);
  const [candidateData, setCandidateData] = useState([]);
  const [candidateLoading, setCandidateLoading] = useState(false);
  const [confirmModal, setConfirmModal] = useState(DEFAULT_CONFIRM_MODAL);
  const [selectedCandidate, setSelectedCandidate] = useState();
  // Define field groups for total, present, and percentage
  const fieldGroups = useMemo(
    () => [
      {
        total: 'questions_2',
        present: 'questions_3',
        percentage: 'questions_4',
      },
      {
        total: 'questions_11',
        present: 'questions_12',
        percentage: 'questions_13',
      },
      {
        total: 'questions_20',
        present: 'questions_21',
        percentage: 'questions_22',
      },
    ],
    []
  );

  let isAdmin = false;
  if (authSelector.role.slug == 'admin') {
    isAdmin = true;
  }

  // Memoized calculation function
  const calculateAttendance = useCallback(
    (total, present, percentageField) => {
      const totalValue = parseFloat(total);
      const presentValue = parseFloat(present);

      if (!isNaN(totalValue) && !isNaN(presentValue) && totalValue > 0) {
        // Calculate percentage
        const calculatedPercentage = (
          (presentValue / totalValue) *
          100
        ).toFixed(2);
        setValue(
          percentageField,
          calculatedPercentage <= 100 ? calculatedPercentage : ''
        );
      } else {
        setValue(percentageField, ''); // Clear the field if invalid
      }
    },
    [setValue]
  );
  // Watch all total and present fields dynamically
  const watchedFields = watch(
    fieldGroups.flatMap(({ total, present }) => [total, present])
  );
  const adhaarFields = [
    'questions_3',
    'questions_8',
    'questions_9',
    'questions_12',
    'questions_17',
    'questions_18',
    'questions_21',
    'questions_26',
    'questions_27',
  ];
  const watchedAdaarFields = watch(adhaarFields);
  // Update attendance percentages when watched fields change
  useEffect(() => {
    fieldGroups.forEach(({ total, present, percentage }, index) => {
      const totalValue = watchedFields[index * 2]; // Even indices: total
      const presentValue = watchedFields[index * 2 + 1]; // Odd indices: present
      calculateAttendance(totalValue, presentValue, percentage);
      // Trigger validation for the present field if it's not blank
      if (presentValue && presentValue !== '') {
        trigger(present); // Revalidate the present field
      }
    });
  }, [
    JSON.stringify(watchedFields),
    calculateAttendance,
    fieldGroups,
    trigger,
  ]);

  useEffect(() => {
    adhaarFields.forEach((field) => {
      return trigger(field);
    });
  }, [JSON.stringify(watchedAdaarFields)]);

  const watchedBioFields = watch([
    'questions_3',
    'questions_6',
    'questions_7',
    'questions_12',
    'questions_15',
    'questions_16',
    'questions_21',
    'questions_24',
    'questions_25',
  ]);
  const calculateAndSetField = (fieldA, fieldB, targetField) => {
    const fieldAValue = Number(watch(fieldA)) || 0;
    const fieldBValue = Number(watch(fieldB)) || 0;

    if (!isNaN(fieldAValue) && !isNaN(fieldBValue)) {
      let calculatedValue = fieldAValue - fieldBValue;
      if (!fieldBValue) {
        calculatedValue = '';
      }
      setValue(
        targetField,
        calculatedValue < 0 ? '' : calculatedValue.toString()
      );
    }
  };

  // Auto-calculate questions_7 based on questions_3 and questions_6
  useEffect(() => {
    trigger('questions_6');
    trigger('questions_15');
    trigger('questions_24');
    calculateAndSetField('questions_3', 'questions_6', 'questions_7');
    calculateAndSetField('questions_12', 'questions_15', 'questions_16');
    calculateAndSetField('questions_21', 'questions_24', 'questions_25');
  }, [JSON.stringify(watchedBioFields)]);
  const getFormattedTime = (title) => {
    const shiftNumber = title.split('-')[1];
    const startTime = examData?.shifts?.[`shift_${shiftNumber}_start_time`];
    if (!startTime || !moment(startTime).isValid()) {
      return ''; // Return empty string if startTime is invalid
    }
    const formattedStartTime = moment(startTime).format('hh:mm A');
    return formattedStartTime;
  };
  const getStatusKey = (name) => {
    // Convert "Shift-1" to "shift1", "Shift-2" to "shift2", and so on
    return name.toLowerCase().replace('-', '');
  };
  const allowOnlyNumbers = (event) => {
    const input = event.target;
    // Remove any non-numeric characters
    input.value = input.value.replace(/[^0-9]/g, '');
  };

  const fetchCandidate = async () => {
    setCandidateLoading(true);
    let response = [];
    try {
      if (isAdmin) {
        response = await SubmissionsAPI.getAllCandidateAdmin(
          id,
          center_cordinator_id
        );
      } else {
        response = await SubmissionsAPI.getAllCandidate(id);
      }

      const data = response?.data;
      if (data) {
        setCandidateData(data?.formattedCandidates || {});
      }
    } catch (error) {
      handleApiError(error);
    } finally {
      setCandidateLoading(false);
    }
  };

  const handleAddCandidate = (shiftNumber) => {
    setAddEditCandidateModal((preveState) => ({
      ...preveState,
      show: true,
      submissionId: id,
      shift: shiftNumber,
      // id: 1,
    }));
  };
  const handleEditCandidate = (row) => {
    setAddEditCandidateModal((preveState) => ({
      ...preveState,
      title: 'Edit Candidate',
      id: row?.id,
      show: true,
      submissionId: id,
      data: row,
    }));
  };
  const resetCandidateModal = (isReload = false) => {
    setAddEditCandidateModal(DEFAULT_CANDIDATE_MODAL);
    if (isReload) {
      fetchCandidate();
    }
  };
  const handleDeleteCandidate = (id) => {
    setSelectedCandidate(id);
    setConfirmModal((preveState) => ({
      ...preveState,
      show: true,
    }));
  };
  const onConfirmAction = async () => {
    setConfirmModal((preveState) => ({ ...preveState, isLoading: true }));
    try {
      await SubmissionsAPI.removeCandidate(selectedCandidate);
      resetCandidateModal(true);
      toast.success('Candidate deleted successfully.');
    } catch (error) {
      handleApiError(error);
    } finally {
      setConfirmModal(DEFAULT_CONFIRM_MODAL);
    }
  };
  const getTextClass = (iris_checked, iris_verified) => {
    if (iris_checked && iris_verified) return 'var(--tblr-success)'; // Both true
    if (iris_checked || iris_verified) return 'var(--tblr-primary)'; // One true
    return 'var(--tblr-border-color)'; // Both false
  };
  const getBgClass = (iris_checked, iris_verified) => {
    if (iris_checked && iris_verified)
      return 'bg-success-lt border shadow-none'; // Both true
    if (iris_checked || iris_verified)
      return 'bg-primary-lt border shadow-none'; // One true
    return ''; // Both false
  };
  useEffect(() => {
    fetchCandidate();
  }, []);
  return (
    <Fragment>
      {shiftData?.map((shift, idx) => {
        const { name, heading, isIncluded } = shift;
        const shiftNumber = idx + 1;
        // if (!isIncluded) return;
        const statusKey = getStatusKey(shift.name); // Get the corresponding key for statuses
        const badgeStatus = statuses[statusKey];
        return (
          <Fragment key={`shiftCard-${idx}`}>
            <CollapsibleCard
              // key={`collapsible-${idx}`}
              title={name}
              badgeStatus={badgeStatus}
              showBadge={true}
              time={getFormattedTime(name)}
              showTime={true}
            >
              {heading.map((item, itemIdx) => {
                const { subcat, questions } = item;
                return (
                  <Fragment key={`heading-${itemIdx}`}>
                    <h3 className='question-heading border-bottom mb-0'>
                      {subcat}
                    </h3>
                    <Card.Body className={`border-bottom p-3`}>
                      <Row className='row-cards'>
                        {questions.map((question, qIdx) => {
                          return (
                            <FormField
                              key={qIdx}
                              label={question.subcat}
                              name={`questions_${question.id}`}
                              type='number'
                              error={reportError?.[`questions_${question.id}`]}
                              register={register}
                              size='12'
                              required
                              pattern='\d*'
                              onInput={allowOnlyNumbers}
                              // max={
                              //   [2, 3, 11, 12, 20, 21].includes(question.id)
                              //     ? "9999"
                              //     : ""
                              // }
                              // onInput={(e) => {
                              //   if (
                              //     [2, 3, 11, 12, 20, 21].includes(question.id) &&
                              //     e.target.value > 9999
                              //   ) {
                              //     e.target.value = 9999; // Cap the value to 9999
                              //   }
                              // }}
                              disabled={
                                examData.submitted ||
                                [4, 13, 22, 7, 16, 25].includes(question.id)
                              }
                            />
                          );
                        })}
                      </Row>
                    </Card.Body>
                  </Fragment>
                );
              })}
            </CollapsibleCard>

            {(Number(watch(`questions_${shiftNumber * 9}`)) ||
              candidateData?.[`shift${shiftNumber}`]?.length) && (
              <CollapsibleCard
                title={`${name}: Aadhaar Bypass ${
                  candidateData?.[`shift${shiftNumber}`]?.length > 0
                    ? `(${candidateData?.[`shift${shiftNumber}`]?.length})`
                    : ''
                }`}
                badgeStatus={badgeStatus}
                showBadge={false}
              >
                <ListGroup variant='flush'>
                  {(candidateData[`shift${shiftNumber}`] || []).map((item) => {
                    const {
                      id,
                      name,
                      error_code,
                      registration_no,
                      iris_checked,
                      iris_verified,
                    } = item;
                    return (
                      <ListGroupItem
                        key={`candidate-${id}`}
                        className='p-3 border-bottom'
                        onClick={() => handleEditCandidate(item)}
                      >
                        <Row className='align-items-center'>
                          <Col xs='auto'>
                            <span
                              className={`avatar rounded-circle bg-primary text-white fs-2 fw-bold `}
                            >
                              {name[0]}
                            </span>
                          </Col>
                          <Col>
                            <div className='fs-18 mb-1'>{name}</div>
                            <div className='text-muted'>{`#${registration_no} | Error #${error_code}`}</div>
                          </Col>
                          <Col xs='auto'>
                            <span
                              className={`avatar avatar-sm rounded-circle shadow-none border ${getBgClass(
                                iris_checked,
                                iris_verified
                              )}`}
                            >
                              <RIconEyeFill
                                fill={getTextClass(iris_checked, iris_verified)}
                              />
                            </span>
                          </Col>
                        </Row>
                      </ListGroupItem>
                    );
                  })}
                </ListGroup>
                <Card.Body className='text-center p-3'>
                  {(!candidateData?.[`shift${shiftNumber}`] ||
                    candidateData?.[`shift${shiftNumber}`]?.length === 0) && (
                    <>
                      <span className='avatar avatar-md rounded-circle mt-2 mb-3 p-3'>
                        <RIconAadharBypass />
                      </span>
                      <p className='fs-18 px-4'>
                        No entries available. Tap the button below to add.
                      </p>
                    </>
                  )}
                  <Button
                    className='w-100'
                    onClick={() => handleAddCandidate(shiftNumber)}
                  >
                    Add Candidate
                  </Button>
                </Card.Body>
              </CollapsibleCard>
            )}
          </Fragment>
        );
      })}
      {addEditCandidateModal.show && (
        <AddEditCandidate
          {...{
            addEditCandidateModal,
            resetCandidateModal,
            handleDeleteCandidate,
            handleSavingCandidate: (formType) => {
              console.log('HANDLESAVINGCANDIDATE', formType);
              handleSave(formType);
            },
          }}
        />
      )}
      {confirmModal.show && (
        // <ConfirmModal
        //   {...confirmModal}
        //   onActionCallback={onConfirmAction}
        //   onHide={() => {
        //     setConfirmModal((preveState) => ({
        //       ...preveState,
        //       show: false,
        //     }));
        //   }}
        // />
        <ConfirmOffcanvas
          isLoading={confirmModal.isLoading}
          iconBgClass='question-heading bg-danger-lt'
          icon={
            <IconTrashFilled className=' text-danger' width={36} height={36} />
          }
          title='Delete'
          description='Are you sure you want to delete?'
          actionBtnText='Delete'
          showWarningText={false}
          show={true}
          onActionCallback={onConfirmAction}
          onHide={() => {
            setConfirmModal((preveState) => ({
              ...preveState,
              show: false,
            }));
          }}
        />
      )}
    </Fragment>
  );
};

export default ShiftQuestions;
